import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ElectricalSidebar from './ElectricalSidebar';
import lt1 from '../../img/LT Switchgear/lt1.png';
import lt2 from '../../img/LT Switchgear/lt2.jpg'

function LTSwitchgear() {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);

  return (
    <section className="py-5 bg-light mt-5" id="lt-switchgear">
      <div className="container">
        <div className="row">
          {/* Main Content */}
          <div className="col-lg-9 col-md-8 mb-4">
            {/* Title */}
            <div className="text-center mb-4" data-aos="fade-up">
              <h2 className="fw-bold">⚡ LT Switchgear</h2>
              <p className="text-muted">
                Reliable control and protection for low-voltage power systems in residential, commercial, and industrial settings.
              </p>
            </div>

            {/* Intro */}
            <div className="mb-4" data-aos="fade-up">
              <p className="text-muted lead">
                LT switchgear is used to control and protect low-voltage electrical circuits in a variety of applications, including residential buildings, commercial complexes, industrial plants, and infrastructure projects. It provides protection against overloads, short circuits, and faults, ensuring safe operation of electrical systems.
              </p>
              <p className="text-muted fw-semibold">Low Voltage Switchgear &nbsp; | &nbsp; Control & Protection</p>
            </div>

            {/* Images */}
            <div className="row mb-4" data-aos="zoom-in">
              <div className="col-md-6 mb-3">
                <img
                  src={lt2}
                  alt="LT Switchgear"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '215px', objectFit: 'cover', width: '100%' }}
                />
              </div>
              <div className="col-md-6 mb-3">
                <img
                  src={lt1}
                  alt="Low Voltage Switchgear Panel"
                  className="img-fluid rounded shadow"
                  style={{ maxHeight: '240px', objectFit: 'cover', width: '100%' }}
                />
              </div>
            </div>

            {/* Ratings */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-primary">📏 Ratings</h4>
              <ul className="text-muted">
                <li><strong>Voltage Class:</strong> Up to 1000V AC</li>
                <li><strong>Current Rating:</strong> 6A to 6300A</li>
                <li><strong>Short Circuit Withstand:</strong> Up to 100kA for 1 sec</li>
                <li><strong>Frequency:</strong> 50/60 Hz</li>
                <li><strong>Insulation Type:</strong> Air-insulated or Resin encapsulated</li>
              </ul>
            </div>

            {/* IEC Standards */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-info">📘 IEC Standards</h4>
              <ul className="text-muted">
                <li><strong>IEC 61439-1 & 2</strong> – Low-voltage switchgear and control gear assemblies</li>
              </ul>
            </div>

            {/* Key Features */}
            <div className="mb-4" data-aos="fade-up">
              <h4 className="text-success">✨ Key Features</h4>
              <ul className="text-muted">
                <li>MCCBs, ACBs, and contactors for circuit protection and control</li>
                <li>Modular construction for easy expansion and flexibility</li>
                <li>Compact design with a small footprint</li>
                <li>Busbar ratings up to 50kA withstand capacity</li>
                <li>Advanced protection against overcurrent, short circuits, and earth faults</li>
                <li>Simple operation with visual indicators for fault diagnostics</li>
                <li>SCADA/PLC integration for automation and remote monitoring</li>
                <li>Safety features like arc flash protection and mechanical interlocks</li>
              </ul>
            </div>
          </div>

          {/* Sidebar */}
          <ElectricalSidebar />
        </div>
      </div>
    </section>
  );
}

export default LTSwitchgear;
